<p-dialog
    [contentStyle]="{ 'min-height': '50vh' }"
    [styleClass]="'sm:col-12 md:col-6 lg:col-5 xl:col-4'"
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    (onHide)="close($event)"
>
    <ng-template pTemplate="header">
        <span class="p-dialog-title">           
            {{'Move' | translate}}
        </span>        
    </ng-template>
    <field-tools class="col-12 md:col-12 lg:col-12" [dataTitle]="'Dest' | translate">
    <dm-fieldset-header [backGround]="false">
        <button class="margin" pButton type="button" (click)="onClickChange()" label="{{'Move_Doc' | translate}}"></button>
    </dm-fieldset-header>
    <div class="scroll-table">       
        <p-tree
            [filter]="true"
            filterPlaceholder="{{'Filter' | translate}}"
            [value]="treeIndex"
            selectionMode="single"
            [(selection)]="selectedFile"
            (onNodeSelect)="nodeSelect($event)"
            (onNodeExpand)="nodeExpand($event)"
            [emptyMessage]="'No_Tree' | translate"
        >
        </p-tree>
    </div>
    </field-tools>
</p-dialog>

